module.exports = __webpack_public_path__ + "img/esteban.20ff2d04.png";